import { useReducer } from "react";

const reducer = (state, action) => {
  switch (action.type) {
    case "SET_CURRENT_PAGE":
      return {
        ...state,
        // update current page and number but DO NOT clear next/prev here
        currentPage: action.page,
        currentPageNum:
          typeof action.pageNum === "number"
            ? action.pageNum
            : state.currentPageNum,
      };
    case "LOAD_MORE":
      return {
        ...state,
        currentPage: action.page,
        isLoadingMore: true,
      };
    case "SET_LOAD_MORE":
      return {
        ...state,
        isLoadingMore: false,
        data: [...state.data, ...action.payload.results],
      };
    case "IS_LOADING":
      return {
        ...state,
        isLoading: action.payload,
      };
    case "FETCH_DATA":
      return {
        ...state,
        isLoading: true,
        data: [],
      };
    case "STORE_DATA":
      return {
        ...state,
        isLoading: false,
        isLoadingMore: false,
        data: action.payload.results ? action.payload.results : action.payload,
        nextPage: action.payload.next,
        prevPage: action.payload.previous,
      };
    case "SET_DATA":
      return {
        ...state,
        data: action.payload,
        nextPage: action.next,
        prevPage: action.prev,
        isLoading: false,
      };
    case "RESET_PAGE":
      return {
        ...state,
        currentPageNum: 1,
        currentPage: action.payload,
        nextPage: null,
        prevPage: null,
      };
    case "SET_SELECTED_ROW":
      return {
        ...state,
        selectedRow: action.selectedRow,
      };
    case "CLOSE_SELECTED_ROW":
      return {
        ...state,
        selectedRow: null,
        editRow: false,
      };
    case "EDIT_ROW":
      return {
        ...state,
        editRow: true,
        selectedRow: action.payload ? action.payload : state.selectedRow,
      };
    case "CLOSE_EDIT_ROW":
      return {
        ...state,
        editRow: false,
      };
    case "OPEN_DOCS":
      return {
        ...state,
        docsModal: true,
      };
    case "CLOSE_DOCS":
      return {
        ...state,
        docsModal: false,
      };
    case "LOAD_PAGE":
      return {
        ...state,
        pageLoading: action.payload,
      };
    case "OPEN_MODAL":
      return {
        ...state,
        [action.key]: action.value,
      };
    case "SET_ERROR":
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        data: [],
        nextPage: null,
        prevPage: null,
      };
    case "UPDATE_DATA":
      return {
        ...state,
        data: action.payload,
      };
    case "UPDATE_ROW":
      return {
        ...state,
        data: state.data.map((row) =>
          row.id === action.payload.id ? action.payload : row
        ),
      };
    default:
      return state;
  }
};

const getInitialState = (route) => ({
  currentPage: route,
  prevPage: null,
  nextPage: null,
  currentPageNum: 1,
  isLoading: true,
  pageLoading: false,
  isLoadingMore: false,
  data: [],
  selectedRow: null,
  advancedSearch: false,
  editRow: false,
  docsModal: false,
});

export const usePaginatedData = (initialPage) => {
  const [state, dispatch] = useReducer(reducer, getInitialState(initialPage));

  const setData = (payload) =>
    dispatch({ type: "STORE_DATA", payload: payload });

  const setDataAndPages = (payload, next = null, prev = null) => {
    dispatch({
      type: "SET_DATA",
      payload: payload,
      next: next,
      prev: prev,
    });
  };

  const updateRow = (updatedData, rowUpdateKey = "id") => {
    const newData = state.data.map((row) => {
      const nested = row[rowUpdateKey];
      if (nested && nested.id === updatedData.id) {
        return {
          ...row,
          [rowUpdateKey]: {
            ...nested,
            ...updatedData,
          },
        };
      }
      return row;
    });
    dispatch({ type: "UPDATE_DATA", payload: newData });
  };

  const resetData = () => dispatch({ type: "RESET" });
  const fetchData = () => dispatch({ type: "FETCH_DATA" });
  const setPage = (page, pageNum = 1) =>
    dispatch({ type: "SET_CURRENT_PAGE", page: page, pageNum: pageNum });
  const nextPage = () => {
    if (!state.nextPage) return;
    dispatch({
      type: "SET_CURRENT_PAGE",
      page: state.nextPage,
      pageNum: state.currentPageNum + 1,
    });
  };
  const prevPage = () => {
    if (!state.prevPage) return;
    dispatch({
      type: "SET_CURRENT_PAGE",
      page: state.prevPage,
      pageNum: state.currentPageNum - 1,
    });
  };
  const setError = (payload) =>
    dispatch({ type: "SET_ERROR", payload: payload });
  const setLoading = (payload) =>
    dispatch({ type: "IS_LOADING", payload: payload });
  const selectRow = (payload) =>
    dispatch({ type: "SET_SELECTED_ROW", selectedRow: payload });
  const setEdit = (payload) =>
    dispatch({ type: payload ? "EDIT_ROW" : "CLOSE_EDIT_ROW" });
  const onLoadMore = (payload) =>
    dispatch({ type: "SET_LOAD_MORE", payload: payload });

  return {
    state,
    setData,
    resetData,
    setPage,
    nextPage,
    prevPage,
    setError,
    dispatch,
    setLoading,
    fetchData,
    selectRow,
    setDataAndPages,
    updateRow,
    setEdit,
    onLoadMore,
  };
};
